import type { FunctionComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { chunkFailed } from '../reload/pageReload'
import { ReloadButton } from '../reload/ReloadButton'
import type { Session } from '../session'

type Card = FunctionComponent<{ session: Session }>
let loaded: Card | null = null

/** The profile card, loaded on first open so it stays out of the hub's initial JS (T3.7). */
export function LazyProfileCard({ session }: { session: Session }) {
  const [Card, setCard] = useState<Card | null>(() => loaded)
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    if (loaded) return
    let live = true
    import('./ProfileCard').then(
      (m) => {
        loaded = m.ProfileCard
        if (live) setCard(() => m.ProfileCard)
      },
      (err: unknown) => {
        // A stale deploy (D-066): the page reloads once; else this slot offers Reload.
        if (live) setFailed(true)
        chunkFailed(err)
      },
    )
    return () => {
      live = false
    }
  }, [])
  if (Card) return <Card session={session} />
  return failed ? <ReloadButton fill /> : null
}
